import { render, staticRenderFns } from "./common.vue?vue&type=template&id=77dc4890&scoped=true"
import script from "./common.vue?vue&type=script&lang=js"
export * from "./common.vue?vue&type=script&lang=js"
import style0 from "./common.vue?vue&type=style&index=0&id=77dc4890&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dc4890",
  null
  
)

export default component.exports